<template>
  <div id="faq-list" class="dashboard-content">
    <p v-show="!editable && faqIsEmpty" class="text-muted">
      QA has not been prepared.
    </p>
    <div>
      <FAQSection
        v-for="(section, index) in startup.faq"
        :key="index"
        :section="section"
        :index="index"
        :editable="editable"
      />

      <div v-show="editable" class="actions">
        <button class="btn btn-primary" @click="addSection()">
          <i class="ion ion-plus-round"></i>
          Add section
        </button>
        <button class="btn btn-primary" @click="save()">
          Save
        </button>
      </div>
      <div class="faq-section"></div>

      <Chat v-show="editable">
        Get the <a target="_blank" href="/perfect-pitch">Perfect Pitch</a>
        e-book for tips on how to fill out the FAQ section!
      </Chat>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/services/notifications'
import FAQSection from './FAQSection.vue'
import { isSectionFilled } from './helpers'
import { some } from 'lodash'
import Chat from '@/components/Chat'

export default {
  components: { FAQSection, Chat },
  props: {
    editable: { type: Boolean, default: false },
  },
  computed: {
    faqIsEmpty() {
      const filledSections = this.startup.faq.map((section) =>
        isSectionFilled(section),
      )
      return !some(filledSections)
    },
    ...mapState({
      startup: (state) => state.startupProfile.startup,
    }),
  },
  methods: {
    addSection() {
      this.$store.commit('startupProfile/ADD_FAQ_SECTION')
    },
    removeSection(index) {
      const section = this.faq[index]

      this.$store.commit('startupProfile/REMOVE_FAQ_SECTION', { section })

      const notification = {
        title: `Section removed: ${section.section}`,
        type: 'warning',
        timeout: 5000,
        action: {
          label: 'Cancel action',
          callback: () => {
            this.$store.commit('startupProfile/RESTORE_FAQ_SECTION', {
              section,
              index,
            })
          },
        },
      }

      this.$store.dispatch('notifications/addItem', notification)
    },

    async save() {
      try {
        await this.$store.dispatch('startupProfile/saveChanges')
      } catch (error) {
        notifications.notify({ title: 'Something went wrong', type: 'danger' })
        return
      }
      notifications.notify({ title: 'FAQ saved', type: 'success' })
    },
  },
}
</script>

<style scoped lang="scss">
@import '~assets/css/colors.scss';
@import '~assets/css/vars.scss';

#faq-list {
  padding: 10px 18px;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.actions {
  margin-top: 28px;
}

.title {
  transition: border-color 0.3s ease;
  margin: 22px 0 26px;

  &:focus {
    border-color: #ffcc33;
  }
}

.faq-section {
  position: relative;
  &:hover .section-actions {
    display: block;
  }
}

.section-actions {
  position: absolute;
  top: 20px;
  right: 5px;
  display: none;

  i {
    cursor: pointer;
    font-size: 22px;
    border-radius: 50%;
    background-color: $yellow;
    width: 30px;
    height: 30px;
  }

  .section-up,
  .section-down,
  .show-help {
    padding: 4px 0 0 8px;
    &:hover {
      background: $yellow120;
    }
  }
  .show-help {
    padding: 4px 0 0 12px;
  }
  .remove-section {
    padding: 4px 0 0 11px;
    &:hover {
      background: $danger;
      color: white;
    }
  }
}

.question {
  font-weight: bold;
  margin-bottom: 1rem;
}

.answer {
  margin-bottom: 2rem;
}
</style>
